import axios from "axios";

const ENDPOINT_KEY = "order";
const ENDPOINT_URI = "/order";

export default function useOrderService() {
  return {
    queryKey: ENDPOINT_KEY,
    getOrders: async (
      orderStatus = "",
      from = "",
      to = "",
      orderNumber = "",
      campaignId = "",
      page = 1,
      limit = 10,
    ) => {
      const params = new URLSearchParams({
        page,
        limit,
      });
      if (orderStatus) {
        params.append("orderStatus", orderStatus);
      }
      if (from) {
        params.append("from", from);
      }
      if (to) {
        params.append("to", to);
      }
      if (orderNumber) {
        params.append("orderNumber", orderNumber);
      }
      if (campaignId) {
        params.append("campaignId", campaignId);
      }
      const response = await axios.get(`${ENDPOINT_URI}/`, {
        params,
      });
      return response.data.payload;
    },
    toggleOrderFlag: async (orderId) => {
      const response = await axios.patch(`${ENDPOINT_URI}/${orderId}/flag`);
      return response.data.payload;
    },
    getOrderById: async (orderId) => {
      const response = await axios.get(`${ENDPOINT_URI}/${orderId}`);
      return response.data.payload;
    },
    getOrdersStatistics: async () => {
      const response = await axios.get(`${ENDPOINT_URI}/stats`);
      return response.data.payload;
    },
    updateOrder: async ({ orderId, payload }) => {
      const response = await axios.put(`${ENDPOINT_URI}/${orderId}`, payload);
      return response.data.payload;
    },
    createOrder: async ({ payload }) => {
      const response = await axios.post(`${ENDPOINT_URI}/`, payload);
      return response.data.payload;
    },
  };
}
